import { BaseDTO } from '../global/base.dto';

export class CalendarEventReminderDTO extends BaseDTO {

    type: number;

    unit: number;

    value: number;

}
